<template>
  <div id="xmsq" class="publicMain">
    <el-row class="leftClass align-i-c">
      <!-- 被授权人 -->
      <el-col :span="bsqrSpan">
        <label style="width: 100px;">{{ $t("xmsq.queryFormbsqr") }}：</label>
        <input-multiple
          :placeholder="'Please select'"
          :multiple="true"
          :collapse-tags="true"
          :size="'small'"
          :value="ryvalue"
          :collapseTags="false"
          :filterable="true"
          @focus="handleFocus()"
          @clear="clear"
          :label="'xm'"
          :value-key="'xm'"
          clearable
        ></input-multiple>
      </el-col>
    </el-row>
    <el-row class="my-10 wt-p-80">
      <!-- 时间选择 -->
      <el-col :span="rqSpan" class="py-5" style="text-align: left;">
        <span class="">{{ $t("xmsq.queryFormqzrq") }}：</span>
        <el-date-picker
          v-model="value2"
          type="daterange"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          size="small"
          style="width:335px"
        >
        </el-date-picker>
      </el-col>
      <!-- 控制金额等选项 -->
      <el-col :span="jeSpan" class="py-5">
        <div class="text-a-l dy-flex my-5">
          <div class="mr-30">
            <el-checkbox v-model="iscqyx" size="large">
              <span class="fs-16 color-b">长期有效</span>
            </el-checkbox>
          </div>
          <div class="mr-30" v-if="btncolor != 'cx'">
            <el-checkbox v-model="kzjeall" size="large">
              <span class="fs-16 color-b">控制金额</span>
            </el-checkbox>
          </div>
          <div class="">
            <el-checkbox v-model="ecsqall" size="large">
              <span class="fs-16 color-b">二次授权</span>
            </el-checkbox>
          </div>
        </div>
      </el-col>
      <!-- 申请/重置 -->
      <el-col :span="anSpan" class="py-5">
        <el-button size="small" type="primary" @click="sqOperateWc">{{
          $t("xmsq.sqBtn")
        }}</el-button>
        <el-button size="small" @click="resetSearch('reset')">{{
          $t("xmsq.resetBtn")
        }}</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table
        v-loading="tabLoading"
        :element-loading-text="$t('elTable.loadingText')"
        element-loading-spinner="el-icon-loading"
        :data="tableData"
        :key="tableKey"
        border
        stripe
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        style="width: 100%; font-size: 12px;"
        @cell-click="cellClick"
        @select="checkboxEvent"
        @select-all="selectionAll"
        :header-cell-style="$store.state.headerCellStyle"
        :cell-style="$store.state.cellStyle"
        :max-height="$store.state.screenHeight - 295"
      >
        <el-table-column
          type="selection"
          width="40"
          key="1"
          align="center"
          header-align="center"
        ></el-table-column>
        <el-table-column
          prop="bmmc"
          :label="$t('xmsq.bmmc')"
          width="220px"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.bmbh }} / {{ scope.row.bmmc }}
          </template>
        </el-table-column>
        <el-table-column
          prop="xmsx"
          :label="$t('xmsq.xmsx')"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{
              scope.row.xmsx == "1"
                ? $t("xmsq.personal")
                : scope.row.xmsx == "2"
                ? $t("xmsq.public")
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="xmmc"
          :label="$t('xmsq.xmmc')"
          width="450px"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            ({{ scope.row.xmbh }}) {{ scope.row.xmmc }} -- {{ scope.row.fzr }}
          </template>
        </el-table-column>
        <el-table-column
          prop="isecsq"
          :label="$t('xmsq.ecsq')"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.isecsq"
              v-show="scope.row.isecsqinp"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-show="!scope.row.isecsqinp">{{
              scope.row.isecsq == "0" ? $t("xmsq.notallow") : $t("xmsq.allow")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="wcqsrq"
          :label="$t('xmsq.qsrq')"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.wcqsrq"
              value-format="yyyy-MM-dd"
              v-if="scope.row.qsrqinp"
              type="date"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
            </el-date-picker>
            <span v-else>{{ scope.row.wcqsrq }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="wcjzrq"
          :label="$t('xmsq.jzrq')"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.wcjzrq"
              value-format="yyyy-MM-dd"
              v-if="scope.row.jzrqinp"
              type="date"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
            </el-date-picker>
            <span v-else>{{ scope.row.wcjzrq }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="yeck"
          :label="$t('xmsq.yeck')"
          v-if="yeckshow"
          key="yeckshow"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.yeck"
              v-show="scope.row.yeckinp"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
              <el-option
                v-for="item in yeckoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-show="!scope.row.yeckinp">{{
              scope.row.yeck == "0" ? $t("xmsq.fou") : $t("xmsq.shi")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="kzsqje"
          :label="$t('xmsq.kzsqje')"
          v-if="kzsqjeeshow"
          width="120px"
          key="kzsqjeeshow"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.kzsqje"
              v-show="scope.row.kzsqjeinp"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
              <el-option
                v-for="item in kzsqjeoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-show="!scope.row.kzsqjeinp">{{
              scope.row.kzsqje == "0" ? $t("xmsq.fou") : $t("xmsq.shi")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="bcsqje"
          :label="$t('xmsq.bcsqje')"
          v-if="bcsqjeshow"
          width="120px"
          key="bcsqjeshow"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.bcsqje"
              v-if="scope.row.bcsqjeinp"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="loseFcous(scope.$index, scope.row)"
            ></el-input>
            <span v-else>{{ jeFormat(scope.row.bcsqje, scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="ysqje"
          :label="$t('xmsq.ysqje')"
          v-if="ysqjeshow"
          key="ysqjeshow"
          align="center"
          header-align="center"
        ></el-table-column>
        <el-table-column
          prop="yhfje"
          :label="$t('xmsq.yhfje')"
          v-if="yhfjeshow"
          key="yhfjeshow"
          align="center"
          header-align="center"
        ></el-table-column>
      </el-table>
    </el-row>
    <xmsqry-dialog
      :title="'选择被授权人'"
      :dialogbsqr="dialogbsqr"
      :tableData="ryxxData"
      :uniqueNum="'Y120101-1-2'"
      :cancelBtn="false"
      :confirmBtn="true"
      :searchPlaceholder="'对工号或姓名筛选'"
      @confirm="confirm"
      @cancel="cancel"
      @searchFilter="searchFilter"
      @handleSelection="handleSelection"
      @selectionAll="selectionAllBsqr"
      v-if="xmsqryFlg"
    >
      <el-row slot="tableHead" class="pb-10">
        <el-select
          v-model="bmvalue"
          filterable
          placeholder="请选择部门"
          size="small"
          class="pr-10"
          @change="bmSelectChange"
        >
          <el-option
            v-for="item in bmOptions"
            :key="item.bmbh"
            :label="item.bmmc"
            :value="item.bmbh"
          >
          </el-option>
        </el-select>
        <el-button type="primary" size="small" @click="showSelected()">{{
          btnText
        }}</el-button>
      </el-row>
      <el-row slot="page">
        <!-- 分页组件 -->
        <Pagination
          :currentPage="currentPage"
          :total="total"
          :limit="limit"
          :small="true"
          :pageSizes="$store.state.pageSizes"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          :uniqueNum="uniqueNum"
        />
      </el-row>
    </xmsqry-dialog>
  </div>
</template>

<script>
import * as yhxx from "@/api/yhxx";
import * as sqgl from "@/api/sqgl";
import InputMultiple from "@/components/InputMultiple.vue";
import XmsqryDialog from "@/components/Dialog_xmsq_ry.vue";
import dateFormat from "@/utils/dateFormat";

export default {
  name: "sqgl",

  components: {
    InputMultiple,
    XmsqryDialog,
  },
  computed: {
    xzxtSpan() {
      let w = this.$store.state.screenWidth;
      if (w > 1920) {
        return 6;
      } else if (1920 >= w && w > 1680) {
        return 8;
      } else if (1680 >= w && w > 1440) {
        return 10;
      } else if (1440 >= w) {
        return 24;
      }
    },
    bsqrSpan() {
      let w = this.$store.state.screenWidth;
      if (w > 1920) {
        return 18;
      } else if (1920 >= w && w > 1680) {
        return 16;
      } else if (1680 >= w && w > 1440) {
        return 14;
      } else if (1440 >= w) {
        return 24;
      }
    },
    rqSpan() {
      let w = this.$store.state.screenWidth;
      if (w > 1920) {
        return 8;
      } else if (1920 >= w && w > 1680) {
        return 8;
      } else if (1680 >= w && w > 1440) {
        return 10;
      } else if (1440 >= w) {
        return 24;
      }
    },
    jeSpan() {
      let w = this.$store.state.screenWidth;
      if (w > 1920) {
        return 13;
      } else if (1920 >= w && w > 1680) {
        return 13;
      } else if (1680 >= w && w > 1440) {
        return 11;
      } else if (1440 >= w) {
        return 24;
      }
    },
    anSpan() {
      let w = this.$store.state.screenWidth;
      if (w > 1920) {
        return 3;
      } else if (1920 >= w && w > 1680) {
        return 3;
      } else if (1680 >= w && w > 1440) {
        return 3;
      } else if (1440 >= w) {
        return 24;
      }
    },
  },
  watch: {
    value2: {
      handler: function(newVal, oldVal) {
        if (newVal == null) {
          newVal = [];
        }
        this.multipleSelection.forEach((item) => {
          this.tableData[item.index].wcqsrq = newVal[0];
          this.tableData[item.index].wcjzrq = newVal[1];
        });
      },
      deep: true, // 开启深度监听
    },
    kzjeall: {
      handler: function(newVal, oldVal) {
        this.multipleSelection.forEach((item) => {
          let data = this.tableData[item.index];
          data.kzsqje = newVal ? "1" : "0";
          data.bcsqje = newVal ? data.ye : "0";
        });
      },
      deep: true, // 开启深度监听
    },
    ecsqall: {
      handler: function(newVal, oldVal) {
        this.multipleSelection.forEach((item) => {
          this.tableData[item.index].isecsq = newVal ? "1" : "0";
        });
      },
      deep: true, // 开启深度监听
    },
    iscqyx: {
      handler: function(newVal, oldVal) {
        if (newVal) {
          const end = new Date();
          const start = new Date();
          end.setTime(start.getTime() + 3600 * 1000 * 24 * (365 * 30 + 7));
          this.value2 = [
            dateFormat.format(start, "yyyy-MM-dd"),
            dateFormat.format(end, "yyyy-MM-dd"),
          ];
        } else {
          this.value2 = [];
        }
      },
      dreep: true,
    },
  },
  data() {
    return {
      btnText: "已选择人员",
      currentPage: 1,
      limit: this.$store.state.dataDisplayNum,
      total: 0, // 数据量
      btncolor: "",
      flg: "0",
      currentRow: null,
      rylbData: [],
      dialogTitle: "人员列表",
      dialogFormVisible: false,
      tableKey: 0,
      queryForm: {
        system: "",
        bsqrzjh: "",
        xm: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t("xmsq.onemonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("xmsq.threemonths"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("xmsq.sixmonths"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("xmsq.cqyx"),
            onClick(picker) {
              const end = new Date("2050-12-31");
              const start = new Date();
              // end.setTime(start.getTime() + 3600 * 1000 * 24 * (365 * 30 + 7));
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      options: [
        {
          value: "1",
          label: "允许",
        },
        {
          value: "0",
          label: "不允许",
        },
      ],
      yeckoptions: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      kzsqjeoptions: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      yhbhoryhmc: "",
      multipleSelection: [],
      selectScope: [],
      value2: [],
      kzjeall: false,
      ecsqall: false,
      yeckshow: false,
      kzsqjeeshow: false,
      bcsqjeshow: false,
      ysqjeshow: false,
      yhfjeshow: false,
      tableData: [],
      tabLoading: false, // 表格请求数据loading层
      disabledFlg: false, // 输入框是否可编辑
      showFlg: false, // 元素是否显示
      screenHeight: "0",
      dialogbsqr: false,
      ryxxDataAll: [],
      activeTableData: [],
      ryxxData: [],
      uniqueNum: "Y120101-1-1",
      value: [],
      yhxx: this.$store.state.yhxx.yhxx,
      ryvalue: [],
      bmOptions: [],
      bmvalue: "",
      searchData: [],
      search: "",
      xmsqryFlg: true,
      iscqyx: false,
    };
  },
  methods: {
    // 根据部门编号查询被授权人
    getSysUserByBmbh(bmbh) {
      yhxx.getSysUserByBmbh({ bmbh: bmbh }).then((res) => {
        this.ryxxDataAll = res.data.data;
        this.activeTableData = this.ryxxDataAll;
        this.dataPaging(this.ryxxDataAll);
      });
    },
    // 被授权人数据分页
    dataPaging(activeTableData) {
      this.ryxxData = [];
      if (activeTableData) {
        this.total = activeTableData.length;
        if (activeTableData.length <= (this.currentPage - 1) * this.limit) {
          this.currentPage = 1;
        }
        let i = (this.currentPage - 1) * this.limit;
        for (
          i;
          i < this.currentPage * this.limit && i < activeTableData.length;
          i++
        ) {
          this.ryxxData.push(activeTableData[i]);
        }
      }
    },
    // 显示已选择被授权人数据
    showSelected() {
      this.searchData = [];
      this.currentPage = 1;
      this.limit = this.$store.state.dataDisplayNum;
      if (this.btnText == "已选择人员") {
        this.activeTableData = this.ryvalue;
        this.btnText = "继续选择人员";
        if (this.search) {
          this.searchFilter(this.search);
        } else {
          this.dataPaging(this.ryvalue);
        }
      } else if (this.btnText == "继续选择人员") {
        this.activeTableData = this.ryxxDataAll;
        this.btnText = "已选择人员";
        // this.dataPaging(this.ryxxDataAll);
        if (this.search) {
          this.searchFilter(this.search);
        } else {
          this.dataPaging(this.ryxxDataAll);
        }
      }
    },
    // 获取部门信息
    getBmxxList() {
      this.bmvalue = this.yhxx.gzbmbh;
      if (this.bmvalue != null && this.bmvalue != "") {
        this.getSysUserByBmbh(this.bmvalue);
      }

      yhxx.getBmxxList().then((res) => {
        this.bmOptions = res.data.data;
      });
    },
    // 部门变化方法
    bmSelectChange(bmbh) {
      this.getSysUserByBmbh(bmbh);
    },
    // 筛选方法
    searchFilter(search) {
      this.search = search;
      if (search) {
        if (this.searchData.length > 0) {
          this.activeTableData = this.searchData;
        }
        let data = [];
        this.activeTableData.filter((item) => {
          if (
            item.xm.toLowerCase().includes(search.toLowerCase()) ||
            item.rydm.toLowerCase().includes(search.toLowerCase())
          ) {
            data.push(item);
          }
        });
        this.searchData = this.activeTableData;
        this.activeTableData = data;
        this.dataPaging(data);
      } else {
        if (this.searchData.length > 0) {
          this.activeTableData = this.searchData;
        }
        this.dataPaging(this.activeTableData);
        this.searchData = [];
      }
    },
    // 表格选中状态改变时方法
    handleSelection(selection) {
      selection.forEach((item, index) => {
        if (item.rydm === this.yhxx.ygbh) {
          this.$message.error("无需对自己授权(" + item.rydm + ")");
          selection.splice(index, 1);
        }
      });
      this.ryvalue = selection;
      // this.getYsqxm();
    },
    // 表格点击全选时方法
    selectionAllBsqr(selection) {
      selection.forEach((item, index) => {
        if (item.rydm === this.yhxx.ygbh) {
          this.$message.error("无需对自己授权(" + item.rydm + ")");
          selection.splice(index, 1);
        }
      });
      this.ryvalue = selection;
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    // 表格点击全选时方法
    selectionAll(selection) {
      this.multipleSelection = [];
      this.selectScope = selection;
      if (this.value2.length > 0) {
        selection.forEach((item) => {
          item.wcqsrq = this.value2[0];
          item.wcjzrq = this.value2[1];
          if (this.kzje != "") {
            item.kzsqje = this.kzje;
          }
        });
      }
      this.multipleSelection = selection;
    },
    // 选中状态改变
    losechange(index, row) {
      if (row.kzsqje == "0" && row.bcsqje > "0.00") {
        this.tableData[index].bcsqje = "0";
      }
      if (row.kzsqje == "1" && row.bcsqje <= "0.00") {
        this.tableData[index].bcsqje = row.ye;
      }
      row.isecsqinp = false;
      row.qsrqinp = false;
      row.jzrqinp = false;
      row.yeckinp = false;
      row.kzsqjeinp = false;
      row.bcsqjeinp = false;
    },
    // 失去焦点
    loseFcous(index, row) {
      row.isecsqinp = false;
      row.qsrqinp = false;
      row.jzrqinp = false;
      row.yeckinp = false;
      row.kzsqjeinp = false;
      row.bcsqjeinp = false;
    },
    // 单击单元格方法
    cellClick(row, column, cell, event) {
      if (column.property === "isecsq") {
        if (row.fzrbh == this.yhxx.ygbh) {
          row.isecsqinp = true;
          this.$nextTick(() => {
            let inp =
              cell.firstElementChild.firstElementChild.firstElementChild;
            inp.click();
          });
        }
      } else if (column.property === "wcqsrq") {
        row.qsrqinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.focus();
        });
      } else if (column.property === "wcjzrq") {
        row.jzrqinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.focus();
        });
      } else if (column.property === "yeck") {
        row.yeckinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.click();
        });
      } else if (column.property === "kzsqje") {
        row.kzsqjeinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.click();
        });
      } else if (column.property === "bcsqje") {
        row.bcsqjeinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.focus();
        });
      }
    },
    // 选择表格方法
    checkboxEvent(scope) {
      this.selectScope = scope;
      let v = this.value2.length > 0;
      scope.forEach((item) => {
        if (v) {
          item.wcqsrq = this.value2[0];
          item.wcjzrq = this.value2[1];
        }
        item.kzsqje = this.kzjeall ? "1" : "0";
        item.isecsq = this.ecsqall ? "1" : "0";
        item.bcsqje = this.kzsqje ? item.ye : "0";
      });
    },
    // 选择状态改变时方法
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 网查授权项目
    getXmsqinfo(system) {
      let _this = this;
      _this.queryForm.system = system;
      _this.tableData = [];
      _this.tabLoading = true; // 关闭请求时的loading层
      sqgl
        .getXmsqinfo(_this.queryForm)
        .then((res) => {
          _this.tabLoading = false; // 关闭请求时的loading层
          if (res.data.code == "200") {
            res.data.data.forEach((item, index) => {
              item.yeck = "0";
              item.kzsqje = "1";
              item.wcqsrq = "";
              item.wcjzrq = "";
              item.index = index;
            });
            _this.tableData = res.data.data;
          }
        })
        .catch((error) => {
          _this.tabLoading = false; // 关闭请求时的loading层
        });
    },

    // 获取被授权人
    getUserinfo() {
      let _this = this;
      if (_this.yhbhoryhmc == "") {
      } else {
        sqgl
          .getUserinfo(_this.$qs.stringify({ yhbhoryhmc: _this.yhbhoryhmc }))
          .then((res) => {
            if (res.data.code == "200") {
              if (res.data.data.ryxx.length == 0) {
                _this.$message.error(_this.$t("xmsq.zbdryxx"));
              }
            }
          });
      }
    },

    // 金额格式化
    jeFormat(je, row) {
      let j = this.$comUtils.moneyFormat(je);
      if (je.replace(/,/g, "") != j.replace(/,/g, "")) {
        row.bcsqje = j;
      }
      return j;
    },

    querenBtn() {
      if (this.flg == "1") {
        this.yhbhoryhmc = this.currentRow.RYDM;
        // this.$refs.yhbhoryhmc2.innerHTML = this.currentRow.XM;
      } else if (this.flg == "2") {
        this.yhbhoryhmc = this.currentRow.XM;
        // this.$refs.yhbhoryhmc2.innerHTML = this.currentRow.RYDM;
      }
      this.dialogFormVisible = false;
    },
    // 确认授权操作
    sqOperateWc() {
      let _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      if (mm < 10) {
        mm = "0" + mm;
      }
      if (dd < 10) {
        dd = "0" + dd;
      }
      let dqDate = yy + "-" + mm + "-" + dd;
      let ok = true;
      let ists = true;
      let tsxx = "";
      if (_this.multipleSelection.length == 0) {
        _this.$message.error(_this.$t("xmsq.qxzsqxm"));
        return false;
      } else if (_this.ryvalue.length == 0) {
        _this.$message.error(_this.$t("xmsq.qsrbsqr"));
        return false;
      }
      for (let i = 0; i < _this.multipleSelection.length; i++) {
        // if (_this.multipleSelection[i].isecsq == "0"){
        //     _this.$message.error('"('+_this.multipleSelection[i].xmbh+')'+_this.multipleSelection[i].xmmc+'"'+_this.$t('xmsq.notallowecsq'));
        //     return false;
        // }else
        if (
          _this.multipleSelection[i].wcqsrq == "" ||
          _this.multipleSelection[i].wcjzrq == ""
        ) {
          _this.$message.error(
            "“（" +
              _this.multipleSelection[i].xmbh +
              "）" +
              _this.multipleSelection[i].xmmc +
              "”" +
              _this.$t("xmsq.rqtxbwz")
          );
          return false;
        } else if (_this.multipleSelection[i].wcqsrq < dqDate) {
          _this.$message.error(
            "“（" +
              _this.multipleSelection[i].xmbh +
              "）" +
              _this.multipleSelection[i].xmmc +
              "”" +
              _this.$t("xmsq.qsrqxydqrq")
          );
          return false;
        } else if (
          _this.multipleSelection[i].wcqsrq > _this.multipleSelection[i].wcjzrq
        ) {
          _this.$message.error(
            "“（" +
              _this.multipleSelection[i].xmbh +
              "）" +
              _this.multipleSelection[i].xmmc +
              "”" +
              _this.$t("xmsq.jzrqdyqsrq")
          );
          return false;
        } else if (
          _this.multipleSelection[i].kzsqje == "1" &&
          _this.multipleSelection[i].bcsqje <= 0
        ) {
          _this.$message.error(
            "“（" +
              _this.multipleSelection[i].xmbh +
              "）" +
              _this.multipleSelection[i].xmmc +
              "”" +
              _this.$t("xmsq.bcsqjexdy0")
          );
          return false;
        } else if (_this.multipleSelection[i].kzsqje == "0") {
          _this.multipleSelection[i].bcsqje = "";
        } else {
          let sqje = parseFloat(_this.multipleSelection[i].bcsqje);
          let ye = parseFloat(_this.multipleSelection[i].ye);
          if (sqje >= ye) {
            tsxx =
              "项目（" +
              _this.multipleSelection[i].xmbh +
              "/" +
              _this.multipleSelection[i].xmmc +
              "）的授权金额已超过项目余额（" +
              _this.multipleSelection[i].ye +
              "）";
            if (_this.yhxx.ygbh === _this.multipleSelection[i].fzrbh) {
              if (sqje > ye) {
                ok = false;
              }
            } else {
              if (sqje === ye) {
                _this.$message.error(
                  "二次授权时，授权金额不能等于剩余金额（" +
                    _this.multipleSelection[i].ye +
                    "）"
                );
              } else {
                _this.$message.error(
                  "二次授权时，授权金额不能超过剩余金额（" +
                    _this.multipleSelection[i].ye +
                    "）"
                );
              }

              return false;
            }
          }
        }
      }
      if (ok) {
        _this
          .$confirm(
            _this.$t("xmsq.Confirmauthorization"),
            _this.$t("xmsq.Confirmationinformation"),
            {
              distinguishCancelAndClose: true,
              confirmButtonText: _this.$t("common.confirmBtn"),
              cancelButtonText: _this.$t("common.cancelBtn"),
            }
          )
          .then((res1) => {
            let data = {};
            let xmList = [];
            let bsqrzjhList = [];
            _this.ryvalue.forEach((item) => {
              bsqrzjhList.push(item.rydm);
              xmList.push(item.xm);
            });
            data.systemType = _this.queryForm.system;
            data.dataList = _this.multipleSelection;
            data.bsqrzjhList = bsqrzjhList;
            data.xmList = xmList;
            sqgl.spOperates(data).then((res) => {
              if (res.data.code == "200") {
                _this.resetSearch();
                _this.getXmsqinfo(_this.queryForm.system);
                _this.$message.success(_this.$t("xmsq.CzSuccess"));
              }
            });
          })
          .catch((action) => {});
      } else {
        _this
          .$confirm(tsxx, "提示", {
            distinguishCancelAndClose: true,
            confirmButtonText: "继续授权",
            cancelButtonText: "取消授权",
            type: "warning",
            center: true,
          })
          .then(() => {
            let data = {};
            let xmList = [];
            let bsqrzjhList = [];
            _this.ryvalue.forEach((item) => {
              bsqrzjhList.push(item.rydm);
              xmList.push(item.xm);
            });
            data.systemType = _this.queryForm.system;
            data.dataList = _this.multipleSelection;
            data.bsqrzjhList = bsqrzjhList;
            data.xmList = xmList;
            sqgl.spOperates(data).then((res) => {
              if (res.data.code == "200") {
                _this.resetSearch();
                _this.getXmsqinfo(_this.queryForm.system);
                _this.$message.success(_this.$t("xmsq.CzSuccess"));
              }
            });
          })
          .catch(() => {
            ok = false;
            // this.$message({
            //   type: "info",
            //   message: "已取消申请",
            // });
          });
      }
    },

    /** 重置操作 */
    resetSearch(typeFlg) {
      this.yhbhoryhmc = "";
      this.clear();
      this.btncolor = "";
      this.tableData = [];
      this.kzjeall = false;
      this.ecsqall = false;
      this.iscqyx = false;
      // this.$refs.yhbhoryhmc2.innerHTML = "";
      // this.value2 = [];
    },
    // 被授权人框获得焦点方法
    handleFocus(event) {
      this.dialogbsqr = true;
    },
    // 选择人员确认
    confirm(ryxx) {
      this.ryvalue = ryxx;
      this.dialogbsqr = false;
    },
    // 取消选择人员
    cancel() {
      this.dialogbsqr = false;
      this.activeTableData = this.ryxxDataAll;
      this.dataPaging(this.ryxxDataAll);
      this.btnText = "已选择人员";
    },
    // 清空选择框
    clear() {
      this.xmsqryFlg = false;
      this.ryvalue = [];
      this.$nextTick(() => {
        this.xmsqryFlg = true;
      });
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.dataPaging(this.activeTableData);
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.limit = val;
      this.currentPage = 1;
      this.dataPaging(this.activeTableData);
    },
  },
  mounted() {
    this.getBmxxList();
  },
};
</script>
<style lang="scss" scoped>
.btnColor {
  background-color: rgb(64, 158, 255);
  color: white;
}
.rightClass {
  margin: 10px 0;
}
.sqcz {
  position: absolute;
  right: 0px;
  top: -40px;
}
.dy-flex-warp {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.xzrq {
  widows: 100%;
  display: flex;
  margin-right: 30px;
  align-items: center;
}
::v-deep .el-checkbox__label {
  display: inline-block;
  padding-left: 5px;
  line-height: 19px;
  font-size: 14px;
}
/* switch按钮样式 */
::v-deep .isWebClass {
  .el-switch__label--left {
    position: relative;
    left: 37px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__core {
    width: 50px !important;
  }

  .el-switch__label--right {
    position: relative;
    right: 37px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }

  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}

::v-deep .isOkClass {
  .el-switch__label--left {
    position: relative;
    left: 52px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__core {
    width: 70px !important;
  }

  .el-switch__label--right {
    position: relative;
    right: 52px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }

  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}
</style>
